var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedScrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58711 4.26592L5.98012 0.882145C5.43698 0.372618 4.5596 0.372618 4.01646 0.882145L0.409467 4.26592C-0.467911 5.089 0.158787 6.5 1.39826 6.5L8.61225 6.5C9.85172 6.5 10.4645 5.089 9.58711 4.26592ZM0.412893 14.7341L4.01989 18.1179C4.56303 18.6274 5.44041 18.6274 5.98354 18.1179L9.59054 14.7341C10.4679 13.911 9.84122 12.5 8.60175 12.5H1.38776C0.148287 12.5 -0.464485 13.911 0.412893 14.7341ZM4.99997 10.5C5.55225 10.5 5.99997 10.0523 5.99997 9.5C5.99997 8.94771 5.55225 8.5 4.99997 8.5C4.44768 8.5 3.99997 8.94771 3.99997 9.5C3.99997 10.0523 4.44768 10.5 4.99997 10.5Z",
    fill: "#0D0A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedScrollIcon);
export default __webpack_public_path__ + "static/media/DeprecatedScrollIcon.367199a646a98a8dafd853d52e2622ee.svg";
export { ForwardRef as ReactComponent };